import { useQuery } from '@apollo/react-hooks';
import React, { lazy, useEffect, useMemo } from 'react';
import { matchPath, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from 'src/hooks/use-auth';
import Loading from '~components/loading';
import { VIEWER } from '~containers/auth/gql';
import useDisplayResponseErrorToast from '~utils/use-display-response-error-toast';
import HomePage from './home-page';

const Login = lazy(() => import(/* webpackChunkName: "Login" */ '~containers/auth'));
const EmailTemplateVariable = lazy(() =>
  import(/* webpackChunkName: "ETVariable" */ '~containers/email-templates/Variable')
);

const EmailCommunication = lazy(() =>
  import(
    /* webpackChunkName: "EmailCommunication" */ '~containers/email-templates/email-communication'
  )
);

function Router() {
  const history = useHistory();
  const location = useLocation();
  const [token] = useAuth();
  const atAuthPage = useMemo(() => !!matchPath(location.pathname, '/auth'), [location.pathname]);

  useEffect(() => {
    if (!token && !atAuthPage) {
      history.replace('/auth/login', { locationAfterLogIn: location });
    }
  }, [atAuthPage, history, location, token]);

  const displayResponseErrorToast = useDisplayResponseErrorToast();
  const { data } = useQuery(VIEWER, {
    skip: !window.localStorage.getItem('token'),
    fetchPolicy: 'cache-first',
    onError: displayResponseErrorToast,
  });

  return (
    <Switch>
      <Route path="/auth/:name">
        <Login />
      </Route>
      <Route path="/settings/booking-config/email-templates/variable">
        <EmailTemplateVariable />
      </Route>
      <Route path="/download/email-communication">
        <EmailCommunication />
      </Route>
      <Route path="/">{!data ? <Loading /> : <HomePage />}</Route>
    </Switch>
  );
}

export default Router;
